import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, Modal } from 'wix-style-react'
import RefreshIcon from 'react-icons/lib/fa/refresh'
import FaCheck from 'react-icons/lib/md/check'
import _ from 'lodash'

import Text from 'components/common/Text'
import PopoverHeader from './PopoverHeader'
// import CustomTabs from './CustomTabs'
import CustomCSSView from './customCSS/CustomCSSView'
import { setCustomFieldArray } from 'controllers/logic'
import { removeFromStorage } from 'controllers/storage'
import IntegrationsButtons from 'components/integrations/IntegrationsButtons'
import ShopifyConnect from 'components/integrations/ShopifyConnect'
import { HELVETICA, LIGHT_BLUE, BLUE, fontSize } from 'components/styles'
import * as integrationType from 'constants/integrationType'
import ProductsList from 'components/integrations/ProductsList'
import AddProduct from 'components/shared/AddProduct'
import { getTemplateByApp } from 'templates/templates'
import { api } from 'api/integrationAPI'

const Container = styled.div`
  // _height: 37em;
  width: 100%;
  ${props => props.popoverSection === 'design' ? 'height: 20em;' : 'height: 85%;'}
  ${props => props.popoverSection === 'design' && 'width: 25em;'}
  ${props => props.popoverSection === 'product' && 'width: 30em;'}
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 8
`
const HeaderText = styled.div`
  width: 100%;
  margin-top: 2em;
  margin-bottom: 2em;
  text-align: center;
  ${HELVETICA};
  font-size: 36px;
  font-weight: 300;
  color: #72a4a3;
`
const IntegrationParamsContainer = styled.div`
  width: 60%
`
const ButtonNextContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 2em;
  align-items: baseline;
`
const Content = styled.div`
  ${fontSize}
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`
const ProductsListContainer = styled.div`
  margin: 1em;
  height: 95%;
`
const HeaderAdditionalBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 1em;
`
const AddProductsButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6em;
  height: 1.5em;
  border: solid 1px #ffffff;
  border-radius: 0.3em;
  cursor: pointer;
  margin-left: 1em;
  background-color: #fff;
  user-select: none;

  &:hover {
    border: solid 1px ${LIGHT_BLUE};
  }
`
const ConnectShopifyButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8em;
  height: 1.5em;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: ${LIGHT_BLUE}
  }
`
const ShopifyConnectIconContainer = styled.div`
  margin-right: 5px;
  display: flex;
  align-items: baseline;
`


const MODE_INTEGRATIONS = 'MODE_INTEGRATIONS'
const MODE_PRODUCTS = 'MODE_PRODUCTS'

class ProductPopover extends Component {

  constructor (props) {
    super(props)
    const integration = this.getIntegration(props.app)
    const mode = integration ? MODE_PRODUCTS : MODE_INTEGRATIONS
    this.state = {
      activeTab: 0,
      selectedIntegration: null,
      addProductModalIsOpen: false,
      editProductId: null,
      mode
    }
  }

  componentWillMount () {
    this.props.updatePosition('10%', '46%')
  }

  componentWillReceiveProps (nextProps) {
    const integration = this.getIntegration(nextProps.app)
    if (integration) this.setState({mode: MODE_PRODUCTS})
  }

  onItemClick = (item) => this.setState({ activeTab: item.id })

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }

  onSelectIntegration = (iType) => this.setState({ selectedIntegration: iType })

  noIntegrationsSelected = () => {
    const { app, dispatch } = this.props
    const path = ['appSettings', 'integration', 'type']
    const integration = this.getIntegration(app)
    if (integration && integration.type === integrationType.NONE) {
      this.setState({mode: MODE_PRODUCTS})
    } else {
      dispatch(setCustomFieldArray(app.id, path, integrationType.NONE))
    }
  }

  renderIntegrationParams = () => {
    const { app } = this.props
    const { selectedIntegration } = this.state
    switch (selectedIntegration) {
      case integrationType.SHOPIFY:
        return (
          <ShopifyConnect
            appId={app.id}
            shopName={_.get(app, ['customFields', 'appSettings', 'integration', 'shopName'])}
            accessToken={_.get(app, ['customFields', 'appSettings', 'integration', 'accessToken'])}
            showDivider={false}
          />
        )
      default:
        return (
          <ButtonNextContainer>
            <Text>Continue with no integration</Text>
            <Button onClick={this.noIntegrationsSelected}>Next</Button>
          </ButtonNextContainer>
        )
    }
  }

  renderIntegrations () {
    const { app } = this.props
    const { selectedIntegration } = this.state
    return (
      <DataContainer>
        <HeaderText>Integrate your ecommerce platform</HeaderText>
        <IntegrationsButtons
          templateId={app.templateId}
          selectedIntegration={selectedIntegration}
          onSelectIntegration={this.onSelectIntegration}
        />
        <IntegrationParamsContainer>
          {this.renderIntegrationParams()}
        </IntegrationParamsContainer>
      </DataContainer>
    )
  }

  getProductsDict = (app) => _.get(app, ['customFields', 'productsDict'], {})
  getIntegration = (app) => _.get(app, ['customFields', 'appSettings', 'integration'])

  onDeleteProduct = (productId) => {
    const { app, dispatch } = this.props
    const productsDict = this.getProductsDict(app)
    const product = productsDict[productId]
    if (product) {
      const template = getTemplateByApp(app)
      const paths = template.pathsByProductId(app, productId)
      for (const path of paths) {
        dispatch(setCustomFieldArray(app.id, path, null))
      }
      dispatch(setCustomFieldArray(app.id, ['productsDict', productId], null))
      for (const asset of product.assets) {
        dispatch(removeFromStorage(app.id, asset.id))
      }
    }
  }

  onSelectProduct = (product) => {
    const { app, dispatch, path } = this.props
    const value = {
      productId: product.productId,
      title: product.title
    }
    dispatch(setCustomFieldArray(app.id, path, value))
  }

  onEditProduct = (productId) => {
    // console.log('onEditProduct', productId)
    this.openAddProductModal(productId)
  }

  renderProductsList () {
    const { app, value } = this.props
    const productsDict = this.getProductsDict(app)
    let productId = _.get(value, 'productId')
    if (productId) productId = productId.toString()
    return (
      <ProductsListContainer>
        <ProductsList
          productsDict={productsDict}
          productId={productId}
          onSelectProduct={this.onSelectProduct}
          onEditProduct={this.onEditProduct}
          onDeleteProduct={this.onDeleteProduct}
        />
      </ProductsListContainer>
    )
  }

  renderProductSelector () {
    if (this.state.mode === MODE_PRODUCTS) {
      return this.renderProductsList()
    } else {
      return this.renderIntegrations()
    }
  }

  renderContent () {
    switch (this.props.popoverSection) {
      case 'product':
        return this.renderProductSelector()
      case 'design':
        return this.renderEditCSS()
      default:
        return null
    }
  }

  closeAddProductModal = () => {
    this.setState({
      addProductModalIsOpen: false,
      editProductId: null
    })
    this.props.setIgnorePopoverOusideClick(true)
  }

  openAddProductModal = (productId = null) => {
    this.setState({
      addProductModalIsOpen: true,
      editProductId: productId
    })
  }

  renderShopifyConnectedCheckIcon (shopifyConnected) {
    if (shopifyConnected) {
      return (
        <ShopifyConnectIconContainer>
          <FaCheck color={'#7ed8ab'} size={20} />
        </ShopifyConnectIconContainer>
      )
    }
  }

  renderShopifyRefreshIcon (shopifyConnected) {
    if (shopifyConnected) {
      return (
        <ShopifyConnectIconContainer>
          <RefreshIcon color={'#7ed8ab'} size={20} />
        </ShopifyConnectIconContainer>
      )
    }
  }

  refreshShopifyProducts = () => {
    console.log('refreshShopifyProducts')
    api.refreshProducts()
  }

  renderContentShopifyButton () {
    const { app } = this.props
    const integration = this.getIntegration(app)
    const shopifyConnected = integration && integration.type === integrationType.SHOPIFY
    const title = shopifyConnected ? 'Shopify Connected' : 'Connect Shopify'
    return (
      <ConnectShopifyButton onClick={shopifyConnected ? this.refreshShopifyProducts : () => this.setState({mode: MODE_INTEGRATIONS})}>
        {/* {this.renderShopifyConnectedCheckIcon(shopifyConnected)} */}
        {this.renderShopifyRefreshIcon(shopifyConnected)}
        <Text size='medium' color='white'>{title}</Text>
      </ConnectShopifyButton>
    )
  }

  renderAdditionalBlock () {
    if (this.state.mode === MODE_PRODUCTS) {
      if (this.props.popoverSection === 'product') {
        return (
          <HeaderAdditionalBlock>
            {this.renderContentShopifyButton()}
            <AddProductsButton onClick={this.openAddProductModal}>
              <Text size='medium' color={BLUE}>Add Products</Text>
            </AddProductsButton>
          </HeaderAdditionalBlock>
        )
      }
    }
  }

  renderAddProductModal () {
    const { app } = this.props
    const { addProductModalIsOpen, editProductId } = this.state
    const productsDict = this.getProductsDict(app)
    const product = _.get(productsDict, editProductId)
    if (addProductModalIsOpen) {
      return (
        <Modal
          zIndex={1000000}
          isOpen
          contentLabel='Add product'
          shouldCloseOnOverlayClick
        >
          <AddProduct
            appId={app.id}
            onClose={this.closeAddProductModal}
            product={product}
          />
        </Modal>
      )
    }
  }

  render () {
    const { app, field, closeMyself } = this.props
    return (
      <Container popoverSection={this.props.popoverSection}>
        <PopoverHeader
          headingDescriptor={(this.props.popoverSection === 'product') ? 'Select Product' : 'Design'}
          // title={this.props.title}
          onClose={closeMyself}
          helpTooltip={'Choose a product from the product list'}
          app={app}
          field={field}
          additionalBlock={this.renderAdditionalBlock()}
        />
        <Content>
          {/*<CustomTabs*/}
          {/*activeTab={this.state.activeTab}*/}
          {/*onClick={this.onItemClick}*/}
          {/*tabsInfo={[{icon: ProductsIcon, name: 'Products'}, {icon: StyleIcon, name: 'Style'}]}*/}
          {/*/>*/}
          {this.renderContent()}
        </Content>
        {this.renderAddProductModal()}
      </Container>
    )
  }
}

ProductPopover.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.object,
  path: PropTypes.array,
  // title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  setIgnorePopoverOusideClick: PropTypes.func,
  popoverSection: PropTypes.string
}

export default connect()(ProductPopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/ProductPopover.js